
export default class ServicesCalculator {

	static getHolderSelectors = () => ['.services-calculator'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		this.#initStep5(holderElement);
		this.#tooltips();
		/** @param {HTMLElement} target */
		window.htmx.onLoad(target => {
			this.#initStep5(target);
			this.#tooltips();
		});
	}

	#initStep5(element) {
		if (element.dataset.scTemplate !== 'step-5') {
			return;
		}
		const modal = new bootstrap.Modal('#services-modal');
		document.querySelectorAll('.select-service-btn:not(.selected), .edit-service-btn').forEach(checkbox => {
			checkbox.addEventListener('click', () => {
				modal.toggle();
			});
		});
	}



	#tooltips() {
		document.querySelectorAll('.info-popup').forEach(e => {
			new bootstrap.Tooltip(e);
		});
	}

}
